import React from "react";
import {getPriceWithVat} from "../../../utils2";

export function UserPrice({basePrice = null, unitPrice, currency = "€", vat, className}) {
    // const priceNumber = parseFloat(unitPrice)
    // const userPrice = vat > 0 ? (priceNumber + (priceNumber * vat / 100)).toFixed(2) : priceNumber

    const applyVat = price => vat > 0 ? getPriceWithVat(price, vat) : price

    const userPrice = applyVat(unitPrice)
    const basePriceVat = basePrice !== null ? applyVat(basePrice) : null

    const userVat = vat > 0 ? `(${vat}% VAT)` : "(excl. VAT)"

    return <>
        <div className="d-flex align-items-center gap-1">
            {basePrice !== null && basePrice !== unitPrice ? (
                <>
                    <div className="text-danger text-decoration-line-through text-nowrap ">{`${currency} ${basePriceVat}`}</div>
                    <div className={`${className || "fs-5 fw-medium"}`}>{`${currency} ${userPrice}`}</div>
                    <div className="text-muted small">{userVat}</div>
                </>
            ) : (
                <>
                    <div className={`${className || "fs-5 fw-medium "}`}>{`${currency} ${userPrice}`}</div>
                    <div className="text-muted small">{userVat}</div>
                </>
            )
            }

        </div>
    </>
}